import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Wstrzymaj nowe zamówienia',
  sections: {
    pause_orders: {
      title: 'Jak długo będziesz niedostępny?',
      description: 'Poinformujemy klientów, że aktualnie nie przyjmujesz nowych zamówień',
    },
    order_methods: {
      title: 'Moje metody zamówień',
      description: 'Włącz lub wyłącz metody składania zamówień przez klientów',
    },
    delivery_mode: {
      title: 'Metody dostawy',
      description: 'Przełącz między własną a naszą siecią kierowców',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 godzina',
        '2_hours': '2 godziny',
        rest_of_day: 'Do końca dnia',
      },
    },
    has_standalone_delivery: {
      label: 'Moi kierowcy',
    },
    has_external_delivery: {
      label: 'Sieć kierowców {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Zamówienia z dostawą wyłączone',
    delivery_orders_on: 'Zamówienia z dostawą włączone',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Czy na pewno chcesz włączyć zamówienia z dostawą?',
        description: '',
      },
      [false]: {
        title: 'Czy na pewno chcesz wyłączyć zamówienia z dostawą?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Czy na pewno chcesz przełączyć się na własnych kierowców?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Czy na pewno chcesz przełączyć się na kierowców {{provider}}?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zapisane pomyślnie',
  },
};
